var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({display: _vm.haveContent? 'inline-block':'none'}),on:{"mousedown":function($event){return _vm.count('down')},"mouseup":_vm.inputCode}},[_c('div',{staticStyle:{"pointer-events":"none"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }